import React, { FC } from 'react';
import { Button } from '@fiverr-private/button';
import pathfinder from '@fiverr-private/pathfinder';
import { getContext } from '@fiverr-private/fiverr_context';
import { guardWithActivation, PhoneVerificationVariant } from '@fiverr-private/code_activation_triggers';
import { AppI18n } from '../../../../i18n';
import { reportPortfolioContactClick } from '../../PortfolioModal.bi';
import { PortfolioProjectSource } from '../../../../gql-operations/gql-generated';
import { usePortfolioModalContext } from '../../PortfolioModalContext';

interface ContactSellerButtonProps {
  sellerUserName: string;
  projectId: string;
  source: PortfolioProjectSource;
}

export const ContactSellerButton: FC<ContactSellerButtonProps> = ({ sellerUserName, projectId, source }) => {
  const { pageCtxId } = getContext();
  const conversationUrl = pathfinder('conversation', { id: sellerUserName });
  const { biEnrichment } = usePortfolioModalContext();
  const pageName = ((biEnrichment.current?.page as Record<string, unknown>)?.name as string) ?? '';

  const openConversation = () => window.open(conversationUrl, '_blank');

  const handleClick = async () => {
    reportPortfolioContactClick({ ctxId: pageCtxId, projectId, projectSource: source });

    await guardWithActivation({
      onSuccess: openConversation,
      sourceComponent: `${pageName}_portfolio_contact`,
      phoneVerificationConfig: { variant: PhoneVerificationVariant.CONTACT },
    });
  };

  return (
    <Button size="sm" onClick={handleClick}>
      <AppI18n k="project_modal.contact_seller" />
    </Button>
  );
};
